/**
 * Training Widget Store
 *
 * Shared state for the minimized training submission widget. CreateModelDialog
 * writes here when the user minimizes during a submission; ActivityPanel reads
 * and renders an inline row so training doesn't occupy a separate floating
 * surface on the canvas.
 */

import { create } from 'zustand'

export type TrainingWidgetStatus = 'preparing' | 'uploading' | 'submitted'

interface TrainingWidgetState {
  visible: boolean
  modelName: string
  status: TrainingWidgetStatus
  uploadProgress: number
  onMaximize: (() => void) | null
  onDismiss: (() => void) | null

  show: (payload: {
    modelName: string
    status: TrainingWidgetStatus
    uploadProgress: number
    onMaximize: () => void
    onDismiss: () => void
  }) => void
  update: (payload: Partial<Pick<TrainingWidgetState, 'status' | 'uploadProgress' | 'modelName'>>) => void
  hide: () => void
}

export const useTrainingWidgetStore = create<TrainingWidgetState>((set) => ({
  visible: false,
  modelName: '',
  status: 'preparing',
  uploadProgress: 0,
  onMaximize: null,
  onDismiss: null,

  show: ({ modelName, status, uploadProgress, onMaximize, onDismiss }) => {
    set({ visible: true, modelName, status, uploadProgress, onMaximize, onDismiss })
  },

  update: (payload) => {
    set((state) => ({ ...state, ...payload }))
  },

  hide: () => {
    set({ visible: false, onMaximize: null, onDismiss: null })
  },
}))
